import _ from 'lodash';
import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import Loader from 'components/Loader';
import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  getSelectedInvoicesForPaymentInitiation,
  previewInvoicesForPaymentInitiation,
  fetchInvoicesForReporting
} from 'ducks/reporting';

import {MODALS as BASE_MODALS, closeModal} from 'ducks/modals';

import {PreviewChargesSection, PaymentForm} from './components';

import './styles.css';

class PreviewInvoicesModal extends React.Component<any> {
  componentDidMount() {
    const {data: {selectedInvoices}} = this.props;
    const extraActions = this.props.storeDataExtraActions(data => ({
      invoices: data
    }));

    this.props.previewInvoicesForPaymentInitiation(
      {
        invoicesIds: selectedInvoices
      },
      extraActions
    );
  }

  getExtraActions = () => {
    const {locationRef} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => closeModal(BASE_MODALS.CONFIRM),
      () => fetchInvoicesForReporting({locationRef})
    ];
  };
  render() {
    const {
      data: {invoicesToPreview, isLoading, form: {isSubmitting}}
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.MEDIUM}
        className="PreviewInvoicesModal">
        <Modal.Header heading="Initiate GoCardless Charges" />

        <PaymentForm
          invoicesToPreview={invoicesToPreview}
          getExtraActions={this.getExtraActions}
          openConfirmationModal={this.props.openConfirmationModal}
        />

        {isLoading && (
          <div className="loaderContainer">
            <Loader />
          </div>
        )}
        {!isLoading && (
          <React.Fragment>
            <Modal.Body>
              <PreviewChargesSection invoicesToPreview={invoicesToPreview} />
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  className="initiatePaymentsButton"
                  onClick={() =>
                    this.props.submit('bulkInitiateGoCardlessPaymentsForm')
                  }
                  blue={!isSubmitting}
                  isLoading={isSubmitting}
                  disabled={isSubmitting || invoicesToPreview.length == 0}>
                  Initiate Charges
                </Button>
              </div>
            </Modal.Footer>
          </React.Fragment>
        )}
      </Modal>
    );
  }
}

const mapStateToModalData = (state, data) => {
  return {
    invoicesToPreview: _.get(data, 'invoices', []),
    selectedInvoices: getSelectedInvoicesForPaymentInitiation(state),
    form: {
      isSubmitting: isSubmitting('bulkInitiateGoCardlessPaymentsForm')(state)
    }
  };
};

const mapDispatchToProps = {
  previewInvoicesForPaymentInitiation,
  submit
};

export default withModal(
  MODALS.PREVIEW_INVOICES_FOR_PAYMENT_INITIATION,
  mapStateToModalData,
  mapDispatchToProps
)(PreviewInvoicesModal);
